import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  height: 520px;
  background-color: ${(props) => props.theme.colors.widget_background};
  border-radius: 12px;
  overflow: hidden;

  .map-wrapper {
    height: 100%;
  }

  .map-container {
    width: 100%;
    height: 100%;
  }
`;

export default { Wrapper };
